import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as DTOS from "../../../../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../../../../actions/dashboard.actions";
import * as DataActionCreators from "../../../../../../actions/data.actions";
import * as MapActionCreators from "../../../../../../actions/map.actions";
import { IAppState } from '../../../../../../app';
import { FilterState } from '../../../../../../reducers/filter.reducer';
import { IBasePageProps } from '../../../../configuration/IConfiguration';
import ContentTabs from '../../../../../Content/ContentTabs';
import PlatypusPlotDetail from '../../../../../Data/Plot/PlatypusPlotDetail';
import PlotResults from '../../../../../Data/Plot/PlotResults';
import { Redirect } from 'react-router';


type PagePlotProps = {
    mapGoogleMapURL: string;
    mapMarkerComponent: any;
}

type PagePlotActions = {
}

type PagePlotRouteParams = {
    plotId: string;
    tabName: string;
}

type PagePlotQueryParams = {
    selectSite?: string;
}

type PagePlotPropsMapped = {
    filter: FilterState;
    monitoringPlot: boolean;
    monitoringPlotLoading: boolean;
    plotSummaryData: any;
    plotSeasonSummaryDataLoading: boolean;
    plotSummaryDataLoading: boolean;
    plot: DTOS.Plot;
    plotLoading: boolean;
    plotEventsLoading: boolean;
}

type PagePlotActionsMapped = {
    deletePlotEvent: typeof MapActionCreators.deleteEventRequest;
    flagPlot: typeof DashboardActionCreators.flagPlotRequest;
    getPlotEvents: typeof DataActionCreators.getPlotEventsRequest;
    getPlotSeasonSummaryData: typeof DataActionCreators.getPlotSeasonSummaryDataRequest;
    getPlotSummaryData: typeof DataActionCreators.getPlotSummaryDataRequest;
    getSinglePlot: typeof DataActionCreators.getSinglePlotRequest;
    getUserPlots: typeof DataActionCreators.getUserPlotsRequest;
}

type PagePlotAllPropsInherited = PagePlotProps & PagePlotActions;
type PagePlotAllPropsMapped = PagePlotPropsMapped & PagePlotActionsMapped;

type PagePlotAllProps = IBasePageProps<PagePlotRouteParams, PagePlotQueryParams> & PagePlotAllPropsMapped & PagePlotAllPropsInherited;

interface IPagePlotState {
    requestedPlotEvents: boolean
}

class PagePlot extends React.Component<PagePlotAllProps, IPagePlotState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            requestedPlotEvents: false
        }
    }

    componentDidMount() {
        if (this.props.routeParams.plotId) {
            this.props.getUserPlots(false);
            this.props.getSinglePlot(Number(this.props.routeParams.plotId));
            this.props.getPlotSummaryData([Number(this.props.routeParams.plotId)], undefined, undefined, undefined);
            this.props.getPlotSeasonSummaryData(Number(this.props.routeParams.plotId));
        }
    }

    componentDidUpdate(prevProps: PagePlotAllProps) {
        const { currentUser, plot } = this.props;

        // need to be logged in for this
        if (currentUser && plot && (!plot.plotEvents || plot.plotEvents.length === 0)) {
            if (!this.props.plotEventsLoading && !this.props.plotLoading && !this.state.requestedPlotEvents) {
                const plotEventLimit = 5;

                this.setState({ requestedPlotEvents: true })
                this.props.getPlotEvents(this.props.plot.id, this.props.currentUser.id, plotEventLimit, undefined, undefined);
            }
        }
    }

    render() {
        const { plot, plotSummaryData } = this.props;

        const plotSeasonSummaryData: DTOS.PlatypusPlotSeasonSummary[] = plot && plotSummaryData && plotSummaryData[plot.id] && plotSummaryData[plot.id].plotSeasonSummaryData
            ? plotSummaryData[plot.id].plotSeasonSummaryData
            : undefined;

        const plotSummary: DTOS.PlotSummary = plot && plotSummaryData && plotSummaryData[plot.id] && plotSummaryData[plot.id].summaryData
            ? plotSummaryData[plot.id].summaryData
            : undefined;

        return (<><ContentTabs
            labelLoading={"loading site"}
            label404={"Could not find site."}
            loading={this.props.plotLoading || this.props.monitoringPlotLoading}
            tabs={[
                {
                    dataReady: this.props.plot !== undefined,
                    label: "Information",
                    labelIcon: "fa-info",
                    component: <PlatypusPlotDetail
                        activePlot={this.props.plot}
                        activePlotId={Number(this.props.routeParams.plotId)}
                        currentUser={this.props.currentUser}
                        dateFormat={this.props.defaultDateFormat}
                        dateTimeFormat={this.props.defaultDateTimeFormat}
                        enableSelectMonitoringPlot={true}
                        googleMapURL={this.props.mapGoogleMapURL}
                        mapMarkerComponent={this.props.mapMarkerComponent}
                        monitoringPlot={this.props.monitoringPlot}
                        plotSummary={plotSummary}
                        plotLoading={this.props.plotLoading}

                        deletePlotEvent={this.props.deletePlotEvent}
                        flagPlot={this.props.flagPlot}
                    />
                },
                {
                    dataReady: this.props.plot !== undefined,
                    label: "Results",
                    labelIcon: "fa-bar-chart",
                    component: <PlotResults
                        activePlot={this.props.plot}
                        activePlotId={Number(this.props.routeParams.plotId)}
                        currentUser={this.props.currentUser}
                        filter={this.props.filter}
                        plotSeasonSummaryData={plotSeasonSummaryData}
                    />
                },
                {
                    dataReady: this.props.plot !== undefined,
                    label: "Edit",
                    labelIcon: "fa-edit",
                    component: <Redirect push to={`/admin/site/${this.props.plot ? this.props.plot.id : -1}`} />,
                    role: "Admin"
                }
            ]}
        /></>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PagePlotAllProps): PagePlotPropsMapped => {

    const plot = state.data.plots ? state.data.plots.find(p => p.id === Number(ownProps.routeParams.plotId)) : undefined;

    const monitoringPlot = state.data.userPlots && plot ? state.data.userPlots.some(p => p.id === plot.id) : false;

    return {
        filter: state.filter,
        monitoringPlot: monitoringPlot,
        monitoringPlotLoading: state.data.userPlotsLoading,
        plot: plot,
        plotSummaryData: state.summaryData.plotSummaryData,
        plotSeasonSummaryDataLoading: state.summaryData.plotSeasonSummaryDataLoading,
        plotSummaryDataLoading: state.summaryData.plotSummaryDataLoading,
        plotLoading: state.data.plotLoading,
        plotEventsLoading: state.data.plotEventsLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PagePlotActionsMapped>({
        deletePlotEvent: MapActionCreators.deleteEventRequest,
        flagPlot: DashboardActionCreators.flagPlotRequest,
        getPlotEvents: DataActionCreators.getPlotEventsRequest,
        getPlotSeasonSummaryData: DataActionCreators.getPlotSeasonSummaryDataRequest,
        getPlotSummaryData: DataActionCreators.getPlotSummaryDataRequest,
        getSinglePlot: DataActionCreators.getSinglePlotRequest,
        getUserPlots: DataActionCreators.getUserPlotsRequest,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)<PagePlotAllPropsInherited>(PagePlot);